// Atoms
import M4Button from "./components/atoms/button/button.vue";
import M4PrintButton from "./components/atoms/print-button/print-button.vue";
import M4Hint from "./components/atoms/hint/hint.vue";
import M4Input from "./components/atoms/input/input.vue";
import M4FileInput from "./components/atoms/file-input/file-input.vue";
import M4Select from "./components/atoms/select/select.vue";
//x import M4Select2 from "./components/atoms/select2/select2.vue";
import M4Multiselect from "./components/atoms/multiselect/multiselect.vue";
import M4Checkbox from "./components/atoms/checkbox/checkbox.vue";
import M4Radio from "./components/atoms/radio/radio.vue";
import M4Tag from "./components/atoms/tag/tag.vue";
import M4Label from "./components/atoms/label/label.vue";
import M4MenuIcon from "./components/atoms/menu-icon/menu-icon.vue";
import M4BrandImage from "./components/atoms/brand-image/brand-image.vue";
import M4Icon from "./components/atoms/icon/icon.vue";
import M4Heading from "./components/atoms/heading/heading.vue";
import M4PageHeading from "./components/atoms/page-heading/page-heading.vue";
import M4SectionHeading from "./components/atoms/section-heading/section-heading.vue";
import M4Iframe from "./components/atoms/iframe/iframe.vue";
import M4Loader from "./components/atoms/loader/loader.vue";
import M4Switch from "./components/atoms/switch/switch.vue";
import M4Status from "./components/atoms/status/status.vue";

// Molecules
import M4Preview from "./components/molecules/preview/preview.vue";
import M4Address from "./components/molecules/address/address.vue";
import M4CheckoutItem from "./components/molecules/checkout-item/checkout-item.vue";
import M4CheckoutTotal from "./components/molecules/checkout-total/checkout-total.vue";
import M4PaymentMethod from "./components/molecules/payment-method/payment-method.vue";
import M4Card from "./components/molecules/card/card.vue";
import M4Wizard from "./components/molecules/wizard/wizard.vue";
import M4Box from "./components/molecules/box/box.vue";
import M4ProgressBar from "./components/molecules/progress-bar/progress-bar.vue";
import M4CheckoutBar from "./components/molecules/checkout-bar/checkout-bar.vue";
import M4HeroCard from "./components/molecules/hero-card/hero-card.vue";
import M4Hero from "./components/molecules/hero/hero.vue";
import M4Menu from "./components/molecules/menu/menu.vue";
import M4Content from "./components/molecules/content/content.vue";
import M4FormField from "./components/molecules/form-field/form-field.vue";
import M4Fieldset from "./components/molecules/fieldset/fieldset.vue";
import M4CheckboxGroup from "./components/molecules/checkbox-group/checkbox-group.vue";
import M4RadioGroup from "./components/molecules/radio-group/radio-group.vue";
import M4Alert from "./components/molecules/alert/alert.vue";
import M4Level from "./components/molecules/level/level";
import M4LevelItem from "./components/molecules/level/level-item";
import M4LevelLeft from "./components/molecules/level/level-left";
import M4LevelRight from "./components/molecules/level/level-right";
import M4UploadField from "./components/molecules/upload-field/upload-field";
import M4MultiUploadField from "./components/molecules/multi-upload-field/multi-upload-field";
import M4CountryField from "./components/molecules/country-field/country-field";
import M4SelectCustomText from "./components/molecules/select-custom-text/select-custom-text";
import M4Separator from "./components/molecules/separator/separator";
import M4Panel from "./components/molecules/panel/panel.vue";
import M4Modal from "./components/molecules/modal/modal.vue";
import M4Dialog from "./components/molecules/dialog/dialog.vue";
import M4LangSwitcher from "./components/molecules/lang-switcher/lang-switcher.vue";
import M4HtmlEditor from "./components/molecules/html-editor/html-editor.vue";
import M4Pagination from "./components/molecules/pagination/pagination.vue";
import M4ContextMenu from "./components/molecules/context-menu/context-menu.vue";
import M4ImagePlaceholder from "./components/molecules/image-placeholder/image-placeholder.vue";
import M4Toast from "./components/molecules/toast/toast.vue";
import M4TabGroup from "./components/molecules/tab-group/tab-group.vue";
import M4Accordion from "./components/molecules/accordion/accordion.vue";
import M4Cart from "./components/molecules/cart/cart.vue";
import M4NumericField from "./components/molecules/numeric-field/numeric-field.vue";
import M4SelectValueFieldGroup from "./components/molecules/select-value-field-group/select-value-field-group.vue";
import M4SelectUnion from "./components/molecules/select-union/select-union.vue";
import M4RadioCheckboxGroup from "./components/molecules/radio-checkbox-group/radio-checkbox-group.vue";
import M4SimpleTable from "./components/molecules/simple-table/simple-table.vue";
import M4PageTitle from "./components/molecules/page-title/page-title.vue";
import M4Token from "./components/molecules/token/token.vue";
import M4BoxWithMenu from "./components/molecules/box-with-menu/box-with-menu.vue";
import M4BoxAccordion from "./components/molecules/box-accordion/box-accordion.vue";
import M4IbanField from "./components/molecules/iban-field/iban-field.vue";
import M4ZoomNav from "./components/molecules/zoom-nav/zoom-nav.vue";
import M4TagGroupField from "./components/molecules/tag-group-field/tag-group-field.vue";
import M4Survey from "./components/molecules/survey/survey.vue";
import M4BoxWithOverlay from "./components/molecules/box-with-overlay/box-with-overlay.vue";
import M4FormFieldAccordion from "./components/molecules/form-field-accordion/form-field-accordion.vue";
//x import M4AssignedPerson from "./components/molecules/assigned-person/assigned-person.vue";

// Organisms
import M4Header from "./components/organisms/header/header.vue";
import M4PageMenu from "./components/organisms/page-menu/page-menu.vue";
import M4ModalImageCropper from "./components/organisms/modal-image-cropper/modal-image-cropper.vue";
import M4SurveyDialog from "./components/organisms/survey-dialog/survey-dialog.vue";
import M4VoucherForm from "./components/organisms/voucher-form/voucher-form.vue";
//x import M4ImageGallery from "./components/organisms/image-gallery/image-gallery.vue";
//x import M4LightBox from "./components/organisms/lightbox/lightbox.vue";
//x import M4TinyForm from "./components/organisms/tiny-form/tiny-form.vue";
//x import M4PeopleList from "./components/organisms/people-list/people-list.vue";
//x import M4SlottingTool from "./components/organisms/slotting-tool/slotting-tool.vue";
//x import M4QrCodeReader from "./components/organisms/qr-code-reader/qr-code-reader.vue";
//x import M4QrCodeChecker from "./components/organisms/qr-code-checker/qr-code-checker.vue";
//x import M4QrCodeSurvey from "./components/organisms/qr-code-survey/qr-code-survey.vue";

// Utils
import M4FormOnce from "./components/utils/form-once.vue";

const components = {
  // Atoms
  M4Button,
  M4PrintButton,
  M4Hint,
  M4Input,
  M4FileInput,
  M4Select,
  //x M4Select2,
  M4Multiselect,
  M4Checkbox,
  M4Radio,
  M4Label,
  M4MenuIcon,
  M4BrandImage,
  M4Icon,
  M4Heading,
  M4PageHeading,
  M4SectionHeading,
  M4Iframe,
  M4Tag,
  M4Loader,
  M4Switch,
  M4Status,
  // Molecules
  M4Card,
  M4Hero,
  M4Menu,
  M4Content,
  M4FormField,
  M4CheckoutItem,
  M4CheckoutTotal,
  M4PaymentMethod,
  M4Address,
  M4Fieldset,
  M4Separator,
  M4CheckboxGroup,
  M4RadioGroup,
  M4Alert,
  M4Level,
  M4LevelItem,
  M4LevelLeft,
  M4LevelRight,
  M4UploadField,
  M4CountryField,
  M4SelectCustomText,
  M4HeroCard,
  M4Panel,
  M4Modal,
  M4Dialog,
  M4LangSwitcher,
  M4HtmlEditor,
  M4Pagination,
  M4ContextMenu,
  M4ImagePlaceholder,
  M4Preview,
  M4Accordion,
  M4Toast,
  M4Cart,
  M4NumericField,
  M4TabGroup,
  M4SelectValueFieldGroup,
  M4SelectUnion,
  M4RadioCheckboxGroup,
  M4Wizard,
  M4Box,
  M4ProgressBar,
  M4CheckoutBar,
  M4SimpleTable,
  M4PageTitle,
  M4Token,
  M4BoxWithMenu,
  M4BoxAccordion,
  M4MultiUploadField,
  M4IbanField,
  M4ZoomNav,
  M4TagGroupField,
  M4Survey,
  M4BoxWithOverlay,
  M4FormFieldAccordion,
  //
  //x M4AssignedPerson,
  //
  // // Organisms
  //x M4PeopleList,
  M4Header,
  M4PageMenu,
  M4ModalImageCropper,
  M4SurveyDialog,
  M4VoucherForm,
  //x M4ImageGallery,
  //x M4LightBox,
  //x M4TinyForm,
  //x M4SlottingTool,
  //x M4QrCodeReader,
  //x M4QrCodeChecker,
  //x M4QrCodeSurvey,
  //
  // // Utils
  M4FormOnce
};

export default components;
